import React, { Component } from 'react';
import { classNames } from 'utils';
import { ContactBanner } from 'views/contact/subcomponents';
import { Banner, WebinarContent } from './subcomponents';
import './Webinar.scss';

class Webinar extends Component {
  render() {
    const {
      banner,
      firstSection,
      secondSection,
      thirdSection,
      fourthSection,
    } = this.props;

    return (
      <div
        className={classNames('single-page single-page--hero webinar-res', {
          'webinar-res--dark': banner.theme === 'dark',
        })}
      >
        {banner && <Banner data={banner} />}
        {/* <Bonus data={bonus} /> */}
        {firstSection && <WebinarContent data={firstSection} />}
        {secondSection && <WebinarContent data={secondSection} />}
        {thirdSection && <WebinarContent data={thirdSection} />}
        {fourthSection && <WebinarContent data={fourthSection} />}
        <ContactBanner
          dataPdWebforms={
            'https://webforms.pipedrive.com/f/cs9dOxJOmE5gaVtA984VfwEuPoJdBsZgEEtvPiKgr6U3hcEK0dU8ApHM9rhP1RzZtx'
          }
        />
      </div>
    );
  }
}

export default Webinar;
